import { Inject, Injectable } from '@angular/core';
import { firstValueFrom, Observable, Subject } from 'rxjs';
import { Logger } from '@obo-main/utils/logger/logger.service';
import { LocalStorage } from '@obo-main/utils/localstorage.service';

@Injectable()
export class RestoreConfigurationService {
    private openModalSub: Subject<void> = new Subject<void>();
    private modalResultSub: Subject<boolean> = new Subject<any>();

    constructor(
        @Inject('BUILD_INFO') protected buildInfo: any,
        @Inject(LocalStorage) private localStorage: any,
        private logger: Logger
    ) {}

    public openModal(): Promise<boolean> {
        this.openModalSub.next();
        return firstValueFrom(this.onModalResult());
    }

    public onModalShow(): Observable<any> {
        return this.openModalSub.asObservable();
    }

    public onModalResult(): Observable<boolean> {
        return this.modalResultSub.asObservable();
    }

    public setModalResult(result: boolean): void {
        this.modalResultSub.next(result);
    }

    /**
     * returns true if an configuration exists in localstorage and is compatible with the current application version
     */
    public isLocalStorageConfigurationAvailable(
        storageKey: string,
        project?: { projectId: number; buildingId: number }
    ): { value: boolean; timeStamp?: number } {
        this.logger.debug('checking if configuration is available in localstorage');
        try {
            const configStr = this.localStorage.getItem(storageKey);
            const configObj = JSON.parse(configStr);
            if (project) {
                return {
                    value:
                        configObj instanceof Object &&
                        configObj.version === this.buildInfo &&
                        configObj.projectId === project.projectId &&
                        configObj.buildingId === project.buildingId,
                    timeStamp: configObj.timeStamp
                };
            }
            return { value: configObj instanceof Object && configObj.version === this.buildInfo, timeStamp: configObj.timeStamp };
        } catch (e) {
            return { value: false };
        }
    }
}
